module.exports = __webpack_public_path__ + "static/img/logo.7fea899.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.png
// module id = 6PsS
// module chunks = 1